// create by nieshu on 2018/11/6
// config
import ETC from '@/config/etc.config'
import APP from '@/config/app.config'
// util
import Plugins from '@/utils/plugins'
// axios
import utilAxios from '@/api/util.axios'
import { zuizhuhaiInit } from '@/utils/channel/zuizhuhai'
import MD5 from 'crypto-js/md5'

const ChannelMixin = {
  methods: {
    c_channelInit() {
      if (this.appChannel === 'zhaohang') {
        window.CMBLS = window.CMBLS || {};
      }
    },
    c_channelAppVersion() {
      if (this.appChannel === 'zhaohang') {
        // console.log('navigator.userAgent', navigator.userAgent)
        const ua = navigator.userAgent.split(' ')
        return (ua.filter(v => v.indexOf('MPBank') > -1)[0] || '').replace('MPBank/', '') || '0.0.0'
      }
      return '0.0.0'
    },
    c_channelIsLogin() {
      if (this.appChannel === 'zhaohang') {
        return sessionStorage.getItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN) && sessionStorage.getItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN) !== 'XXXX'
      }
    },
    c_channelLogin() {
      return new Promise(async (re, rj) => {
        switch (this.appChannel) {
          // case 'zhaohang':
          //   let corpNo = APP.ZSBANK_CORPNO
          //   let secretKey = APP.ZSBANK_SECRETKEY
          //   if (this.c_channelAppVersion() >= '7.4.0') {
          //     const login = await Plugins.zhaohangLogin(corpNo, secretKey)
          //     if (!login) {
          //       re(false)
          //     } else {
          //       console.log('axios bank cmb login v2')
          //       // 招行登陆
          //       const aa = await utilAxios.jsonInstance.post('/bank/cmb/auth/login-v2', { sResponseXml: login.body })
          //       localStorage.setItem(ETC.LOCAL_STORAGE_KEY.UUID, aa.cmb_uid)
          //       sessionStorage.setItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN, localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID) || '')
          //       re(true)
          //     }
          //   } else {
          //     console.log('zhaohang channelLogin uid ' + sessionStorage.getItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN))
          //     if (sessionStorage.getItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN) && sessionStorage.getItem(ETC.SESSION_STORAGE_KEY.ZHAO_HANG_LOGIN) !== 'XXXX') {
          //       console.log('浏览器测试/已登录')
          //       re(true)
          //     } else {
          //       let param = { channel: 'zhaohang' }
          //       let url = APP.HTTP_URL.replace('https://', '').replace('http://', '')
          //       let a = (`tplogins://${url}/bank/cmb/auth/login?param=${encodeURIComponent(JSON.stringify(param))}&corpno=${corpNo}${secretKey}`).toLowerCase()
          //       let auth = MD5(a)
          //       location.href = (`tplogins://${url}/bank/cmb/auth/login?param=${encodeURIComponent(JSON.stringify(param))}&corpno=${corpNo}&auth=${auth}`).toLowerCase()
          //       re(false)
          //     }
          //   }
          //   break;
          case 'zuizhuhai':
            zuizhuhaiInit()
              .then(res => {
                re(true)
              })
              .catch(err => {
                rj(err)
              })
            break;
          // case 'pahcz':
          //   // const tokenD = await axios.post('https://test-api.pingan.com.cn:20443/oauth/oauth2/access_token',
          //   //   {
          //   //     client_id: 'P_ETC_ASSISTANT',
          //   //     grant_type: 'client_credentials',
          //   //     client_secret: 'TH34Ptr3'
          //   //   }, {'Content-Type': 'application/json'})
          //   // console.log(tokenD)
          //   re(true)
          //   break;
          default:
            re(true)
            break;
        }
      })
    }
  }
}
export default ChannelMixin
